import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { TextAreaField } from '../../../components/fields';
import { history } from './../../../configuration/store';
import { Field, reduxForm } from 'redux-form';
import messages from '../../../text/messages';
import { updateTimesheet, confirmTimesheet } from '../../../reducers/timekeeping';
import Modal from '../../../components/modal';

class PreviewWeek extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            modal: false
        };

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.handleSubmitTimesheet = this.handleSubmitTimesheet.bind(this);
    }

    openModal() {
        this.setState({ modal: true });
    }

    closeModal() {
        this.setState({ modal: false });
    }

    handleSubmitTimesheet(values) {
        const { confirmTimesheet, updateTimesheet, timesheet, reload } = this.props;
        const { worker_notes } = values;

        const isDashboard = ['/dashboard', '/'].includes(window.location.pathname);

        updateTimesheet({ ...timesheet, worker_notes }, () => {
            confirmTimesheet(timesheet.id, () => {
                this.closeModal();
                isDashboard ? reload() : history.push('/dashboard');
            });
        });
    }

    render() {
        const { shifts, fromTo, handleSubmit, isMobile, isIC } = this.props;
        const { modal } = this.state;

        const closeButton = (
            <div className="col-xs-12 col-sm-4">
                <div className="preview-cancel" onClick={this.closeModal}>
                    <FormattedMessage {...messages.goBackAndEdit} />
                </div>
            </div>
        );

        const submitButtonLabel = isIC ? messages.submitWeeklyInvoice : messages.submitTimesheet;
        const reviewTitle = (isIC = false) => (isIC ? messages.reviewInvoiceTitle : messages.reviewTimesheetTitle);

        const submitButton = (
            <div className="col-xs-12 col-sm-8">
                <button className="preview-submit" type="submit">
                    <FormattedMessage {...submitButtonLabel} />
                </button>
            </div>
        );

        const submitWarning = (
            <div className="row">
                <div className="col-xs-12">
                    <div className="preview-warning">
                        <FormattedMessage {...messages.submittingWarning} />
                    </div>
                </div>
            </div>
        );

        return (
            <div>
                <span className="button pull-right" onClick={this.openModal}>
                    <FormattedMessage {...submitButtonLabel} />
                </span>
                <Modal
                    open={modal}
                    onClose={this.closeModal}
                    size="col-sm-8 col-sm-offset-2 col-xs-12"
                    title={
                        <React.Fragment>
                            <b>
                                <FormattedMessage {...reviewTitle(isIC)} />
                            </b>
                            <br />
                            <FormattedMessage {...messages.fromto} values={fromTo} />
                        </React.Fragment>
                    }
                >
                    <form onSubmit={handleSubmit(values => this.handleSubmitTimesheet(values))}>
                        <div className="row preview-wrapper">
                            <div className="col-xs-12">{shifts}</div>
                        </div>
                        <div className="row preview-wrapper-time-worker">
                            <div className="col-xs-12">
                                <Field rows={3} component={TextAreaField} placeholder={messages.notes} name="worker_notes" />
                            </div>
                        </div>
                        {!isIC && submitWarning}
                        <div className="row preview-buttons">
                            {isMobile ? (
                                <div>
                                    {submitButton}
                                    {closeButton}
                                </div>
                            ) : (
                                <div>
                                    {closeButton}
                                    {submitButton}
                                </div>
                            )}
                        </div>
                    </form>
                </Modal>
            </div>
        );
    }
}

PreviewWeek.propTypes = {
    shifts: PropTypes.element,
    weekTotal: PropTypes.object,
    fromTo: PropTypes.object,
    isMobile: PropTypes.bool,
    disabled: PropTypes.bool
};

PreviewWeek = reduxForm({
    destroyOnUnmount: false,
    enableReinitialize: true,
    forceUnregisterOnUnmount: true
})(PreviewWeek);

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            updateTimesheet,
            confirmTimesheet
        },
        dispatch
    );

PreviewWeek = connect(null, mapDispatchToProps)(PreviewWeek);

export default PreviewWeek;



// WEBPACK FOOTER //
// ./src/pages/timekeeping/components/previewWeek.jsx